import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Dataset } from '../models/dataset.model';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  calculateDelta(data$: Observable<number[]>): Observable<number[]> {
    return data$
      .pipe(
        map(data => {
          const delta = [];
          delta[0] = data[0];
          for (let i = 1; i < data.length; i++) {
            delta.push(data[i] - data[i - 1]);
          }
          return delta;
        }));
  }

  divideArrays(a: number[], b: number[]): any[] {
    return a.map((n, i) => {
      return ((n / b[i]) * 100).toFixed(4);
    });
  }


  sort(data: number[], countries: string[]): Dataset[] {
    return data.map((v, i) => ({
      rate: v,
      country: countries[i]
    })).sort((o1, o2) => o2.rate - o1.rate);
  }

}
